module.exports = __webpack_public_path__ + "static/media/alignTop.8e562d85.svg";